<template>
  <div class="col-lg-12">
    <div class="row d-flex justify-content-between">
      <div class="d-flex align-items-center">
        <span class="ml-2 label-bold color-dark-purple">CERTIFICADOS</span>
      </div>
      <div>
        <button
          type="button"
          class="f14 btn-add-items-tb bg-light-purple color-white"
          @click="openForm()"
        >
          ADICIONAR
        </button>
      </div>
    </div>
    <div class="mt-3">
      <div
        class="d-flex justify-content-center align-item-center row mb-1 border-dark-purple pt-3 pb-4"
        v-if="certifications.length === 0"
      >
        <h4 class="center f15 color-dark-purple">
          NENHUMA CERTIFICAÇÃO FOI INFORMADA AINDA.
        </h4>
      </div>
    </div>

    <div
      v-for="(certification, index) in certifications"
      :key="certification.id"
    >
      <div class="mt-3">
        <div class="row mb-1 border-dark-purple pt-3 pb-4">
          <div class="col-lg-12">
            <div>
              <div class="d-flex justify-content-between">
                <div>
                  <span
                    class="label-bold color-dark-purple"
                    style="text-transform: capitalize"
                  >{{ certification.name }}</span>
                </div>
                <div
                  style="margin-right: 10px !important"
                  class="menu_column nav nav-tabs"
                >
                  <li
                    style="background-color: #f4f4f4 !important"
                    class="nav-item dropdown"
                  >
                    <div
                      class="nav-link"
                      data-toggle="dropdown"
                      role="button"
                      aria-haspopup="true"
                      aria-expanded="false"
                      style="background-color: #fcfcfc"
                    >
                      <font-awesome-icon icon="ellipsis-h" />
                    </div>
                    <div class="dropdown-menu drop-down-tb">
                      <div class="dropdown-item pointer">
                        <span
                          class="mt-0 mb-0"
                          @click="openForm(certification.id)"
                        >
                          EDITAR
                        </span>
                        <i class="ml-4 fa fa-pencil-alt scale_1" />
                      </div>
                      <div class="dropdown-item pointer">
                        <span
                          class="mt-0 mb-0"
                          @click="deleteCertifications(certification.id, index)"
                        >
                          DELETAR
                        </span>
                        <i class="ml-3 fas fa-trash-alt scale_1" />
                      </div>
                    </div>
                  </li>
                </div>
              </div>
              <div>
                <span style="text-transform: capitalize">{{ certification.institution }}</span>  
              </div>
              <div>
                <div>
                  <span style="text-transform: capitalize">
                    {{ certification.start_date }} - {{ certification.end_date }}
                  </span>
                </div>
              </div>
              <div class="mt-3">
                <div>
                  <span>Descrição:</span>
                </div>
                <div>
                  <span style="text-transform: capitalize">{{
                    certification.description
                  }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import CertificationsForm from "./Form.vue";
import { format } from "date-fns";
import axios from "axios";

export default {
  props: ["candidate_id"],
  mounted() {

    eventBus.$on("getCertifications", () => {
      this.getCertifications();
    });
    axios.get('/candidates/extra_courses/search?query=abc').then((response) => {
    })
    this.getCertifications();
  },
  data: () => ({
    certifications: [],
  }),
  methods: {
    getCertifications() {
      this.certifications = [];
      let url = "/candidates/extra_courses";
      if (this.candidate_id) {
        url = `/recruiters/talent_banks/${this.candidate_id}/extra_courses`;
      }
      axios.get(url).then((response) => {
        for (let certification of response.data.extra_courses) {
          if( certification.type_courses === 2 ){
            this.certifications.push({
              id: certification.id,
              name: certification.name,
              description: certification.description,
              start_date: certification.start_date
                ? format(new Date(certification.start_date), "MM/yyyy")
                : "",
              end_date: certification.end_date
                ? format(new Date(certification.end_date), "MM/yyyy")
                : "",
              institution: certification.institution_name,
            });
          }
        }
      });
    },
    openForm(id) {
      this.$modal.show(
        CertificationsForm,
        {
          certification_id: id,
          candidate_id: this.candidate_id,
        },
        {
          width: "70%",
          height: "auto",
          scrollable: true,
        }
      );
    },
    deleteCertifications(id, index) {
      let conf = confirm("Tem certeza que deseja excluir este dado?");
      if (!conf) return;

      let url = `/candidates/extra_courses/${id}`;
      if (this.candidate_id) {
        url = `/recruiters/talent_banks/extra_courses/${id}`;
      }

      axios.delete(url).then((response) => {
        if (response.data.status) {
          this.$toast.success("Certificação excluída com sucesso!");
          this.certifications.splice(index, 1);
          return;
        }

        this.$toast.error("Não foi possivel excluir esta certificação.");
      });
    },
  },
};
</script>